export default "__VITE_ASSET__Bfs6yZCA__"